import { render, staticRenderFns } from "./Objeto.vue?vue&type=template&id=5ce088a0&scoped=true&"
import script from "./Objeto.vue?vue&type=script&lang=js&"
export * from "./Objeto.vue?vue&type=script&lang=js&"
import style0 from "./Objeto.vue?vue&type=style&index=0&id=5ce088a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce088a0",
  null
  
)

export default component.exports